import React, { useRef } from "react";
import { motion, useInView } from "framer-motion";

const Services = () => {
    const subheading = "Our Services";
    const heading = "Empowering Businesses with Skilled Talent";

    const serviceList = [
        {
            title: "Recruitment & Staffing",
            description:
                "From entry-level hiring to executive search, we identify and place the right candidates who align with your vision and culture.",
        },
        {
            title: "End-to-End HR Services",
            description:
                "We manage everything from employee onboarding to exit formalities, including documentation, HR policy implementation, leave and attendance management, and employee relations.",
        },
        {
            title: "Payroll & Compliance Management",
            description:
                "Ensure timely and accurate payroll processing, PF/ESIC registration, labor law compliance, and statutory filings with our expert support.",
        },
        {
            title: "Training & Development",
            description:
                "We offer customized training programs to upskill your workforce in communication, soft skills, leadership, and job readiness.",
        },
        {
            title: "HR Consulting",
            description:
                "Our HR consultants provide strategic guidance, help set up HR processes, create policies, and align your HR function with your business goals.",
        },
    ];


    const splitWords = (text) => text.split(" ").map((word, i) => ({ word, key: i }));

    const textRef = useRef(null);
    const isInView = useInView(textRef, { once: true, margin: "-100px" });

    return (
        <>
            <div className="services-main-v9">
                {/* Heading Section */}
                <motion.div
                    ref={textRef}
                    initial="hidden"
                    animate={isInView ? "visible" : "hidden"}
                    variants={{
                        visible: {
                            transition: {
                                staggerChildren: 0.06,
                            },
                        },
                    }}
                >
                    {/* Subheading */}
                    <motion.p className="service-home-subheading-v9">
                        {splitWords(subheading).map(({ word, key }) => (
                            <motion.span
                                key={`sub-${key}`}
                                className="service-page-p"
                                variants={{
                                    hidden: { opacity: 0, y: 15 },
                                    visible: { opacity: 1, y: 0 },
                                }}
                            >
                                {word}&nbsp;
                            </motion.span>
                        ))}
                    </motion.p>

                    {/* Heading */}
                    <motion.h2 className="service-page-h1">
                        {splitWords(heading).map(({ word, key }) => (
                            <motion.span
                                key={`head-${key}`}
                                className="about-home-heading-word-v9"
                                variants={{
                                    hidden: { opacity: 0, y: 20 },
                                    visible: { opacity: 1, y: 0 },
                                }}
                            >
                                {word}&nbsp;
                            </motion.span>
                        ))}
                    </motion.h2>
                </motion.div>

                {/* Service Cards Section */}
                <div className="services-card-container">
                    {serviceList.map((service, index) => (
                        <motion.div
                            key={index}
                            className="service-card"
                            initial={{ opacity: 0, y: 30 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true }}
                            transition={{ duration: 0.5, delay: index * 0.1 }}
                        >
                            <h3 className="service-card-title">{service.title}</h3>
                            <p className="service-card-description">{service.description}</p>
                        </motion.div>
                    ))}
                </div>
            </div>
        </>
    );
};

export default Services;
